import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";

import "./TrustedBrands.css";
import Icons from "../../../../config/images";

const brands = [
  Icons.finibali_brand_logo,
  Icons.carat_start_brand_logo,
  Icons.soni_jewellers_brand_logo,
  // Icons.carat_start_brand_logo_updated,
  // Icons.soni_jewellers_brand_logo_updated,
  Icons.zabali,
  Icons.finibali_brand_logo,
  Icons.carat_start_brand_logo,
  Icons.soni_jewellers_brand_logo,
  // Icons.carat_start_brand_logo_updated,
  // Icons.soni_jewellers_brand_logo_updated,

  Icons.zabali,
];

const TrustedBrands = () => {
  return (
    <motion.section
      className="trusted-brands-section"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="trusted-brands-header">
        <h2>Trusted by Jewellery Businesses</h2>
        <p>
          From retailers to manufacturers, jewellery brands trust BA Code
          Solution for reliable and customized digital solutions that deliver
          real business value.
        </p>
      </div>

      <Swiper
        modules={[Autoplay]}
        loop={true}
        speed={5000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        slidesPerView={5}
        spaceBetween={20}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 16 },
          768: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1280: { slidesPerView: 5, spaceBetween: 24 },
        }}
        className="trusted-brands-swiper"
      >
        {brands.map((logo, index) => (
          <SwiperSlide key={index}>
            <div className="brand-logo-wrapper">
              <img src={logo} alt="Brand Logo" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default TrustedBrands;
